import { Component, Inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PersistentSetting, PersistentSettingParent, Tag } from '@entscheidungsnavi/widgets';
import { AuthService, ProjectDto, QuickstartProjectDto } from '@entscheidungsnavi/api-client';
import { OverlayProgressBarDirective } from '@entscheidungsnavi/widgets/overlay-progress-bar';
import { ProjectFolderDto, TeamProjectInfoWithRoleDto } from '@entscheidungsnavi/api-types';

type ProjectListEntry = QuickstartProjectDto | ProjectDto | TeamProjectInfoWithRoleDto;

export type ProjectListModalData = {
  quickstart: boolean;
  projectList: readonly ProjectListEntry[];
  folderList: readonly ProjectFolderDto[];
  tags: Tag[];
  query?: string;
  tagFilter?: string[];
};

export type ProjectListModalResult = {
  loadedProject: boolean;
  projects: readonly ProjectListEntry[];
  projectFolders: readonly ProjectFolderDto[];
};

@Component({
  templateUrl: './project-list-modal.component.html',
  styleUrls: ['./project-list-modal.component.scss'],
  hostDirectives: [OverlayProgressBarDirective],
  standalone: false,
})
@PersistentSettingParent('ProjectListModal')
export class ProjectListModalComponent {
  projects: readonly ProjectListEntry[];
  projectFolders: readonly ProjectFolderDto[];

  quickstart: boolean;

  @PersistentSetting()
  private filterTextTemplates = '';
  @PersistentSetting()
  private filterTextUserProjects = '';

  get filterText() {
    return this.quickstart ? this.filterTextTemplates : this.filterTextUserProjects;
  }

  set filterText(value: string) {
    if (this.quickstart) {
      this.filterTextTemplates = value;
    } else {
      this.filterTextUserProjects = value;
    }
  }

  @PersistentSetting()
  filterTagIds: readonly string[] = [];

  tags: Tag[] = [];

  constructor(
    private authService: AuthService,
    @Inject(MAT_DIALOG_DATA) data: ProjectListModalData,
    private dialogRef: MatDialogRef<ProjectListModalComponent, ProjectListModalResult>,
  ) {
    this.quickstart = data.quickstart;
    this.projects = data.projectList;
    this.projectFolders = data.folderList;
    this.tags = data.tags;

    if (data.query != null) {
      this.filterTextTemplates = data.query;
    }

    if (data.tagFilter != null) {
      this.filterTagIds = data.tagFilter;
    }

    this.filterTextUserProjects = '';

    if (this.quickstart) {
      this.projectFolders = [];
    } else {
      this.authService.onLogout$.pipe(takeUntilDestroyed()).subscribe(() => {
        this.dialogRef.close();
      });
    }
  }

  closeModal(loadedProject: boolean) {
    this.dialogRef.close({ loadedProject, projects: this.projects, projectFolders: this.projectFolders });
  }
}
